import { all } from 'redux-saga/effects';
import dataSaga from '../sagas/dataSaga/dataSaga';
import initSaga from '../sagas/initSaga/initSaga';
import modelSaga from '../sagas/modelSaga/modelSaga';
import trainedModelSaga from '../sagas/trainedModelSaga/trainedModelSaga';
import modelDataSaga from '../sagas/modelDataSaga/modelDataSaga';
import accessSaga from '../sagas/accessSaga/accessSaga';



export default function* rootSaga(): Generator {
    yield all([
        ...accessSaga,
        ...dataSaga,
        ...initSaga,
        ...modelSaga,
        ...trainedModelSaga,
        ...modelDataSaga
    ])
}